import React, { Fragment } from 'react'
import classNames from 'classnames'
import propTypes from 'prop-types'

import Link from '../Link'

const Swedish = ({
  className,
  heading = true,
  intro = true,
  matomo = true,
  options = {},
}) => {
  const realOptions = {
    headingTag: 'h1',
    headingClassName: 'heimr-section__heading',
    subHeadingTag: 'h2',
    subHeadingClassName: 'heimr-section__sub-heading',
    ...options,
  }
  const classes = classNames('heimr-section', className)

  return (
    <section className={classes}>
      {heading && (
        <Heading
          Tag={realOptions['headingTag']}
          className={realOptions['headingClassName']}
        />
      )}
      <div className='heimr-section__content'>
        {intro && <Intro />}
        {matomo && (
          <Matomo
            HeadingTag={realOptions['subHeadingTag']}
            headingClassName={realOptions['subHeadingClassName']}
          />
        )}
      </div>
    </section>
  )
}

const Heading = ({ Tag, className }) => <Tag className={className}>Cookies</Tag>

const SectionText = ({ children }) => (
  <p className='heimr-section__text'>{children}</p>
)

const SectionLink = ({ children, to }) => (
  <Link className='heimr-section__link' to={to}>
    {children}
  </Link>
)

const SectionList = ({ children }) => (
  <ul className='heimr-section__list'>{children}</ul>
)

const Intro = () => (
  <Fragment>
    <SectionText>
      Den här webbplatsen använder cookies av nedanstående anledningar. Om du
      inte vill använda cookies kan du enkelt stänga av det i din webbläsare, se
      exempelvis{' '}
      <SectionLink to='https://www.cookiesandyou.com/disable-cookies'>
        cookiesandyou.com:s guide
      </SectionLink>{' '}
      för hur man gör det.
    </SectionText>
  </Fragment>
)

const Matomo = ({ HeadingTag, headingClassName }) => (
  <Fragment>
    <HeadingTag className={headingClassName}>Webbstatistik</HeadingTag>
    <SectionText>
      För att kunna utvärdera och utveckla webbplatsen används analysverktyget{' '}
      <SectionLink to='https://matomo.org'>Matomo</SectionLink>.{' '}
      <SectionLink to='https://accodeing.com'>
        Vår hemsideleverantör
      </SectionLink>{' '}
      hanterar analysdatan och skickar inte vidare den till någon tredjepart.
    </SectionText>

    <SectionList>
      <li>Inga användar-ID:n sparas</li>
      <li>
        Vissa interaktioner kan sparas, till exempel om man fyller i ett
        formulär
      </li>
      <li>
        All individuell data tas bort automatiskt efter 90 dagar och då finns
        bara sammanslagna rapporter från alla besökare kvar
      </li>
    </SectionList>

    <SectionText>Den informationen som samlas in är:</SectionText>

    <SectionList className='heimr-section__list'>
      <li>Anonymiserat IP-nummer, sista oktetten (192.168.1.xxx)</li>
      <li>Datum och tid för serveranropen</li>
      <li>Titel på och URL till de sidorna du besöker</li>
      <li>URL:en till föregående sida (Referrer URL)</li>
      <li>Skärmupplösning</li>
      <li>Lokal tid</li>
      <li>Filer som du klickar på och laddar ner</li>
      <li>Länkar till externa sidor som du klickar på (Outlink)</li>
      <li>Tiden det tar att ladda sidan i din webbläsare</li>
      <li>
        Ungefär var i världen du befinner dig (land, region, stad, ungefärliga
        koordinater) utifrån din IP-adress (Geolocation). Vi använder INTE några
        GPS-koordinater. Lokalisering via IP-nummer är inte speciellt exakt.
      </li>
      <li>Förvalt språk i din webbläsare (Accept-Language header)</li>
      <li>Vilken webbläsare du använder (User-Agent header)</li>
    </SectionList>
  </Fragment>
)

Swedish.propTypes = {
  className: propTypes.string,
  heading: propTypes.bool,
  intro: propTypes.bool,
  matomo: propTypes.bool,
  options: propTypes.shape({
    headingTag: propTypes.string,
    headingClassName: propTypes.string,
    subHeadingTag: propTypes.string,
    subHeadingClassName: propTypes.string,
  }),
}

export default Swedish
